import { useRouterStore } from "../../Stores/Router";
import { useHelpCenterStore } from "../../Stores/HelpCenter";
import { ArticleDetailView } from "./HelpCenterArticle/HelpCenterArticle";
import {
  CollectionsView,
  CollectionDetailView,
} from "./HelpCenterCollection/HelpCenterCollection";
import { SearchView } from "./HelpCenterSearch/HelpCenterSearch";
import { PasswordGate } from "./HelpCenterPasswordGate/HelpCenterPasswordGate";
import "./HelpCenter.scss";

function HelpCenter() {
  const routerStore = useRouterStore();
  const currentPage = routerStore.currentPage;
  const currentData = routerStore.currentData;
  const requiresPassword = useHelpCenterStore((s) => s.requiresPassword);

  if (requiresPassword) {
    return (
      <div className="helpcenter">
        <PasswordGate />
      </div>
    );
  }

  if (currentPage === "helpcenter-article" && currentData?.id) {
    return (
      <div className="helpcenter helpcenter--tabbar--hidden">
        <ArticleDetailView articleId={currentData.id} />
      </div>
    );
  }

  if (currentPage === "helpcenter-collection" && currentData?.id) {
    return (
      <div className="helpcenter helpcenter--tabbar--hidden">
        <CollectionDetailView collectionId={currentData.id} />
      </div>
    );
  }

  if (currentPage === "helpcenter-search") {
    return (
      <div className="helpcenter">
        <SearchView term={currentData?.term ?? ""} />
      </div>
    );
  }

  return (
    <div className="helpcenter">
      <CollectionsView />
    </div>
  );
}

export default HelpCenter;
